import React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

function JobListingsPage(props) {

    var { t } = useTranslation();
    var navigate = useNavigate();

    var jobs = [
        {
            id: 1,
            title: "Warehouse Loader for Food Distribution Company in Almaty",
            description: "This position involves assisting with daily warehouse operations at a food distribution hub in Almaty. Responsibilities include unloading delivery trucks, moving boxes and pallets of groceries, maintaining order inside the storage facility, and preparing shipments for retail clients. The job requires basic physical strength, ability to follow supervisor instructions, and punctuality. Knowledge of Russian is preferred since safety briefings and work instructions are provided in Russian.",
            city: "Almaty",
            salary: "180 000 ₸ – 200 000 ₸",
            image: "https://img.freepik.com/free-photo/warehouse-worker-carrying-box_1098-18039.jpg"
        },
        {
            id: 2,
            title: "Barista and Waiter in Coffeehouse Chain in Astana",
            description: "This role is within a mid-size café chain in Astana, where the employee will be responsible for preparing espresso-based drinks, serving customers at tables, cleaning the workspace, and managing cashless payments at the counter. The atmosphere is friendly but fast-paced. Training is provided, but Russian communication is mandatory since interaction with both colleagues and guests is frequent. Previous café or hospitality experience is an advantage, but not required.",
            city: "Astana",
            salary: "210 000 ₸ – 230 000 ₸",
            image: "https://img.freepik.com/free-photo/barista-making-coffee_23-2147686966.jpg"
        },
        {
            id: 3,
            title: "Delivery Driver for Small Van in Shymkent",
            description: "The driver will operate a small delivery van transporting goods from warehouses to retail stores. Tasks include loading and unloading items, maintaining daily logs, and ensuring safe delivery within city limits. The role requires valid driving documents and safe handling of fragile products. Knowledge of Russian is strongly recommended since clients and traffic police communicate primarily in Russian.",
            city: "Shymkent",
            salary: "240 000 ₸ – 260 000 ₸",
            image: "https://img.freepik.com/free-photo/delivery-man-holding-box_23-2148176122.jpg"
        },
        {
            id: 4,
            title: "Construction Site Helper for Residential Housing Project in Astana",
            description: "A physically demanding position assisting masons, painters, and electricians on a construction site. Duties involve carrying bricks, mixing cement, moving materials across the work area, cleaning up after shifts, and helping with scaffolding. Training on safety measures is provided. Basic Russian is helpful to follow instructions quickly in an active environment. Suitable for those comfortable with outdoor, year-round work.",
            city: "Astana",
            salary: "220 000 ₸ – 240 000 ₸",
            image: "https://img.freepik.com/free-photo/construction-worker-carrying-wood_23-2148296008.jpg"
        },
        {
            id: 5,
            title: "Hotel Cleaning Staff in Borovoye Resort Area",
            description: "This job is at a tourist hotel complex in Borovoye. Responsibilities include making beds, cleaning bathrooms, vacuuming carpets, replacing towels, and maintaining general cleanliness in guest rooms and hallways. The environment is structured, with shifts typically starting in the morning and finishing in the afternoon. Friendly demeanor and attention to detail are key. Russian is not strictly mandatory but helpful for communicating with supervisors and reception staff.",
            city: "Borovoye",
            salary: "180 000 ₸ – 200 000 ₸",
            image: "https://img.freepik.com/free-photo/hotel-housekeeping-cleaning-room_23-2149188399.jpg"
        },
        {
            id: 6,
            title: "Kitchen Assistant at Casual Dining Restaurant in Almaty",
            description: "This role involves washing dishes, cutting vegetables, cleaning kitchen areas, and assisting the main chef during busy service hours. The kitchen is fast-paced and requires discipline and cleanliness. Russian is often used in instructions from chefs, so basic understanding is useful. Evening shifts are common, and meals are included during working hours.",
            city: "Almaty",
            salary: "190 000 ₸ – 210 000 ₸",
            image: "https://img.freepik.com/free-photo/kitchen-helper-cutting-vegetables_23-2149327492.jpg"
        },
        {
            id: 7,
            title: "Car Wash Attendant at Outdoor Facility in Astana",
            description: "The attendant will clean and polish cars at a busy car wash center. Tasks include spraying, applying soap, wiping, vacuuming interiors, and interacting with clients when needed. The work is physical and requires attention to detail. Customers often communicate in Russian, so understanding basic terms is important. Tips may be earned from satisfied customers.",
            city: "Astana",
            salary: "170 000 ₸ – 190 000 ₸",
            image: "https://img.freepik.com/free-photo/man-washing-car_23-2148351452.jpg"
        },
        {
            id: 8,
            title: "Street Cleaner and Maintenance Worker in Central Almaty",
            description: "This municipal job requires sweeping streets, collecting trash, and maintaining public cleanliness in designated districts of Almaty. Work is outdoors in all weather conditions and follows an early morning schedule. It is steady employment provided by local services. Minimal communication is needed, but Russian understanding is a benefit for coordination with team leaders.",
            city: "Almaty",
            salary: "160 000 ₸ – 180 000 ₸",
            image: "https://img.freepik.com/free-photo/street-cleaner-worker-orange-uniform_23-2148921322.jpg"
        },
        {
            id: 9,
            title: "Port Dock Worker for Cargo Handling in Aktau",
            description: "This position involves physical labor at the Aktau seaport, where responsibilities include moving cargo, assisting crane operators, securing loads, and maintaining the dock area. Safety equipment is provided. Shifts may involve night work. Russian is required to follow strict safety instructions and team coordination.",
            city: "Aktau",
            salary: "240 000 ₸ – 270 000 ₸",
            image: "https://img.freepik.com/free-photo/port-worker-hard-hat_23-2148795943.jpg"
        },
        {
            id: 10,
            title: "Seasonal Farm Worker in Borovoye Agricultural Cooperative",
            description: "This role is seasonal work during planting and harvesting periods in Borovoye fields. Tasks include planting seeds, picking vegetables, carrying produce crates, and maintaining irrigation. Work is long and outdoors, but accommodation and meals are often included. Russian is not mandatory, but some phrases are useful for coordination with local supervisors.",
            city: "Borovoye",
            salary: "150 000 ₸ – 170 000 ₸",
            image: "https://img.freepik.com/free-photo/farm-worker-harvesting-cabbage_23-2149424381.jpg"
        },
        {
            id: 11,
            title: "Security Guard at Shopping Center in Astana",
            description: "The guard will stand at entrances, monitor security cameras, check bags when necessary, and provide basic safety for visitors. Training is given on conflict prevention and emergency procedures. Night shifts are common. Russian language is required for communication with management and visitors.",
            city: "Astana",
            salary: "200 000 ₸ – 230 000 ₸",
            image: "https://img.freepik.com/free-photo/security-guard-standing-mall_23-2149176401.jpg"
        },
        {
            id: 12,
            title: "Construction Painter and Helper in Almaty High-Rise Project",
            description: "The worker assists painters in applying paint, cleaning surfaces, moving scaffolds, and preparing equipment. Work is physical and requires tolerance of heights. Safety training is included. Russian is helpful for teamwork coordination. The project is large-scale and involves long-term employment opportunities.",
            city: "Almaty",
            salary: "200 000 ₸ – 220 000 ₸",
            image: "https://img.freepik.com/free-photo/construction-worker-painting-wall_23-2148199493.jpg"
        },
        {
            id: 13,
            title: "Janitor and Building Cleaner in Office Center in Astana",
            description: "Duties include cleaning floors, collecting trash, washing windows, and maintaining public restrooms inside an office building. The job requires early morning or evening shifts. Russian is useful to communicate with supervisors. This role offers steady, simple work for reliable individuals.",
            city: "Astana",
            salary: "160 000 ₸ – 180 000 ₸",
            image: "https://img.freepik.com/free-photo/janitor-cleaning-office-floor_23-2149334599.jpg"
        },
        {
            id: 14,
            title: "Courier for Online Food Delivery Service in Almaty",
            description: "The courier is responsible for picking up food from restaurants and delivering it to customers within Almaty. The job requires a smartphone, knowledge of city streets, and ability to use navigation apps. Russian is needed for communicating with clients and dispatchers. Income may include tips in addition to salary.",
            city: "Almaty",
            salary: "210 000 ₸ – 240 000 ₸",
            image: "https://img.freepik.com/free-photo/food-delivery-courier-carrying-bag_23-2148887468.jpg"
        },
        {
            id: 15,
            title: "Hotel Porter and Luggage Assistant in Borovoye Resort Hotel",
            description: "Responsibilities include greeting guests, carrying luggage to rooms, helping with basic inquiries, and maintaining lobby cleanliness. The job requires polite behavior and presentable appearance. Russian is mandatory since guest interaction is constant. This is a stable role within the hospitality sector.",
            city: "Borovoye",
            salary: "180 000 ₸ – 200 000 ₸",
            image: "https://img.freepik.com/free-photo/hotel-bellman-carrying-luggage_23-2149108299.jpg"
        },
        {
            id: 16,
            title: "Dishwasher and Kitchen Helper at Family Café in Aktau",
            description: "This role requires maintaining cleanliness of dishes, utensils, and kitchen equipment, as well as assisting with food preparation during busy hours. Shifts are often in the evening. Russian is required to understand work instructions and cooperate with staff. Meals are included as a benefit.",
            city: "Aktau",
            salary: "160 000 ₸ – 180 000 ₸",
            image: "https://img.freepik.com/free-photo/dishwasher-cleaning-restaurant-kitchen_23-2149306421.jpg"
        },
        {
            id: 17,
            title: "Gas Station Attendant in Astana",
            description: "Responsibilities include assisting customers with refueling, maintaining station cleanliness, and processing payments. The work involves standing outdoors for long periods. Russian is required for customer service. The position offers steady income and night shift availability.",
            city: "Astana",
            salary: "180 000 ₸ – 200 000 ₸",
            image: "https://img.freepik.com/free-photo/gas-station-worker-helping-customer_23-2148792332.jpg"
        },
        {
            id: 18,
            title: "Seasonal Park Cleaner in Borovoye National Park",
            description: "This role involves maintaining walking paths, collecting trash, sweeping picnic areas, and ensuring cleanliness for visiting tourists. Work is outdoors and seasonal, typically spring to autumn. Russian is optional, but some phrases help when interacting with supervisors or visitors. Accommodation may be provided near the park.",
            city: "Borovoye",
            salary: "150 000 ₸ – 170 000 ₸",
            image: "https://img.freepik.com/free-photo/park-cleaner-working-outdoors_23-2149311223.jpg"
        }
    ];

    return (
        <div className="uk-container uk-margin-large-top uk-margin-large-bottom">

            {/* Filters card */}
            <div className="uk-card uk-card-default uk-card-body uk-box-shadow-medium uk-margin-bottom">
                <h3 className="uk-card-title">{t("Filters")}</h3>

                <form className="uk-grid-small uk-child-width-1-2@m" uk-grid="true">

                    {/* City */}
                    <div>
                        <label className="uk-form-label">{t("City")}</label>
                        <select className="uk-select">
                            <option>Almaty</option>
                            <option>Astana</option>
                            <option>Shymkent</option>
                            <option>Karaganda</option>
                            <option>Aktobe</option>
                        </select>
                    </div>

                    {/* Urban / Rural */}
                    <div>
                        <label className="uk-form-label">{t("Location Type")}</label>
                        <div className="uk-form-controls uk-form-controls-text">
                            <label><input className="uk-radio" type="radio" name="locationType" /> {t("Urban")}</label><br />
                            <label><input className="uk-radio" type="radio" name="locationType" /> {t("Rural")}</label>
                        </div>
                    </div>

                    {/* Job Type */}
                    <div>
                        <label className="uk-form-label">{t("Job Type")}</label>
                        <select className="uk-select">
                            <option>{t("Manual Labor")}</option>
                            <option>{t("Skilled/Professional")}</option>
                        </select>
                    </div>

                    {/* Language Requirements */}
                    <div>
                        <label className="uk-form-label">{t("Languages Required")}</label>
                        <div className="uk-form-controls uk-form-controls-text">
                            <label><input className="uk-checkbox" type="checkbox" /> {t("Russian")}</label><br />
                            <label><input className="uk-checkbox" type="checkbox" /> {t("Kazakh")}</label>
                        </div>
                    </div>

                    {/* Benefits */}
                    <div>
                        <label className="uk-form-label">{t("Benefits")}</label>
                        <div className="uk-form-controls uk-form-controls-text">
                            <label><input className="uk-checkbox" type="checkbox" /> {t("Meals Provided")}</label><br />
                            <label><input className="uk-checkbox" type="checkbox" /> {t("Transport Provided")}</label>
                        </div>
                    </div>

                    {/* Keyword Search */}
                    <div>
                        <label className="uk-form-label">{t("Keyword Search")}</label>
                        <input className="uk-input" type="text" placeholder={t("Enter keywords")} />
                    </div>

                    {/* Industry / Sector */}
                    <div>
                        <label className="uk-form-label">{t("Industry / Sector")}</label>
                        <select className="uk-select">
                            <option>{t("Cleaning")}</option>
                            <option>{t("Hospitality")}</option>
                            <option>{t("Agriculture")}</option>
                            <option>{t("Loader")}</option>
                            <option>{t("Courier")}</option>
                            <option>{t("Driver")}</option>
                        </select>
                    </div>
                </form>
            </div>


            {/* Job listings */}
            <div className="uk-child-width-1-1 uk-grid-small" uk-grid="true">
                {
                    jobs.map(function (job) {
                        return (
                            <div key={job.id}>
                                <div className="uk-card uk-card-default uk-card-hover uk-grid-collapse uk-margin" uk-grid="true">
                                    {/* Image */}
                                    <div className="uk-card-media-left uk-cover-container uk-width-1-4@m">
                                        <img src={job.image} alt={job.title} uk-cover="true" />
                                        <canvas width="150" height="150"></canvas>

                                        {/* Subtle city badge */}
                                        <div className="uk-overlay uk-position-bottom-left uk-padding-small">
                                            <span className="uk-label" style={{ background: "#2d3a74" }}>{job.city}</span>
                                        </div>
                                    </div>


                                    {/* Content */}
                                    <div className="uk-width-expand@m">
                                        <div className="uk-card-body">
                                            <h3 className="uk-card-title">{job.title}</h3>
                                            <p className="uk-text-truncate">{job.description}</p>

                                            <div className="uk-grid-small uk-child-width-1-1 uk-child-width-expand@m uk-flex-middle" uk-grid="true">
                                                {/* Salary on the left */}
                                                <div>
                                                    <span className="uk-text-large uk-text-bold uk-text-primary">{job.salary}</span>
                                                </div>

                                                {/* Buttons and heart on the right */}
                                                <div className="uk-flex uk-flex-right@m uk-flex">

                                                    <button
                                                        className="uk-button uk-button-default uk-margin-small-right"
                                                        onClick={function () {
                                                            navigate("/jobs/" + job.id, { state: { job: job } });
                                                        }}
                                                    >
                                                        {t("Details")}
                                                    </button>

                                                    <button className="uk-button uk-button-jai uk-margin-small-right">
                                                        {t("APPLY")}
                                                    </button>

                                                    <a href="#" className="uk-icon-button uk-margin-small-right" uk-icon="heart"></a>
                                                    
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        );
                    })
                }
            </div>
        </div>
    );
}

export default JobListingsPage;
